export class DHLAuth {
    DHLUsername: any; 
    DHLPassword: any; 
} 